module.exports = __webpack_public_path__ + "static/media/Alaa Al-Mashhadi.f6efaeb8.jpg";